import React from "react";

import styles from "./EmptyResult.module.scss";
import BrokenSearch from "../Icons/BrokenSearch";
import Text from "../Text/Text";
import SquareButton from "../Buttons/SquareButton";

interface EmptyResultProps {
    title: string;
    details: string;
    buttonCta?: string;
    linkCta?: React.ReactElement<any, any>;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => void;
}

const EmptyResult = (props: EmptyResultProps & React.HTMLProps<HTMLDivElement>) => {
    const {
        title,
        details,
        buttonCta,
        linkCta,
        onClick = () => { },
        ...restProps
    } = props;

    return (
        <div className={styles.container} {...restProps}>
            <BrokenSearch className={styles.icon} />
            <Text textStyle="heading-3" className={styles.title}>{title}</Text>
            <Text textStyle="sans-serif-body" className={styles.details}>{details}</Text>
            {
                buttonCta
                && <SquareButton className={styles.cta} color="outline" onClick={onClick}>{buttonCta}</SquareButton>
            }
            {
                linkCta
                && <Text textStyle="sans-serif-body" className={styles.linkCta}>{linkCta}</Text>
            }
        </div>
    );
};

export { EmptyResult as default };
export type { EmptyResultProps };
